import React, { ReactElement } from 'react'
import {
    ThemeProvider as MUIThemeProvider, createTheme,
} from '@mui/material/styles'
import skyThemeRaw from '@skycell-ag/theme'

import localTheme from './theme'

type Props = {
    children: ReactElement,
}

const theme = createTheme(skyThemeRaw, localTheme())

const ThemeProvider = ({ children }: Props) => {
    return (
        <MUIThemeProvider
            theme={theme}
        >
            {children}
        </MUIThemeProvider>
    )
}

export default ThemeProvider
